<template>
  <div class="bhbox">
    <div class="bhbanner">
      <div class="topheader">
        <div class="wd12 topfix flex space-ar">
          <img src="@/assets/images/tjbh/logo.png" class="toplogo" alt />
          <div class="topmenu">
            <div class="menuitem" @click="gohref(item.path)" v-for="(item,index) in urllist" :key="index">
              {{item.name}}
              <div class="menuline" :style="($route.path==item.path || ($route.path=='/notice/detail' && item.path=='/notice/list'))?'opacity:1':'opacity:0'"></div>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center;">
          <div class="toplogin" @click="goLogins" style="margin-right:8px;" v-if="!$store.state.token">登录</div>
          <div
          class="flex align-items-center user-box"
          v-else
          @click.stop
          @click="shouUserMore = !shouUserMore"
        >
          <!-- <a-avatar
            style="width: 30px; height: 30px; margin-right: 15px"
            icon="user"
          /> -->
          <div class="flex align-items-center">
            <div
              style="max-width: 120px; min-width: 50px"
              class="nowrap"
              :title="$store.state.user.realname"
            >
              {{ $store.state.user.realname }}
            </div>
            <img class="img-small" src="@/assets/images/img41.png" alt="" />
          </div>
          <div class="user-more" @click.stop v-if="shouUserMore">
            <!-- <div
              class="user-more-item"
              @click="
                shouChangepw = true;
                shouUserMore = false;
              "
            >
              修改密码
            </div> -->
            <div
              class="user-more-item"
              v-if="$store.state.role != 'draw-role'"
              @click="
                gojump
              "
            >
              网络育人创新联盟
            </div>
            <div
              class="user-more-item"
              v-else
              @click="
                gojumpS
              "
            >
              抽签
            </div>
            <div style="border-top: 1px solid #ccc"></div>
            <div class="user-more-item" @click="logout">退出登录</div>
          </div>
        </div>
        <!-- <div class="toplogins" @click="goRegister" v-if="!$store.state.token">注册</div>-->
        </div> 
        </div>
      </div>
    </div>
    <div style="min-height:500px;">
      <router-view></router-view>
    </div>
    <div class="footer">
      <div class="wd12 footerw">
        <img src="@/assets/images/bh/logo.png" class="bottomlogo" alt />
        <img src="@/assets/images/bh/sline.png" class="bottomline" alt />
        <div class="bottomheight">
          <p class="bottomtext">天津渤海职业技术学院</p>
          <p class="bottomtext">地址：天津市北辰区津榆公路508号</p>
        </div>
      </div>
    </div>
    <div class="loginPop flex flex-center align-items-end" v-if="showLoginPop">
      <login @close="close" @loginSuccess="showLoginPop = false"></login>
    </div>
    <div v-if="shouChangepw">
      <a-modal v-model="shouChangepw" title="修改密码">
        <p style="margin-top: 15px">原密码</p>
        <a-input
          type="password"
          placeholder="请输入原密码"
          v-model="passwordEdit.oldpassword"
        />
        <p style="margin-top: 15px">新密码</p>
        <a-input
          placeholder="请输入新密码"
          type="password"
          v-model="passwordEdit.password"
        />
        <p style="margin-top: 15px">确认密码</p>
        <a-input
          type="password"
          placeholder="请输入确认密码"
          v-model="passwordEdit.confirmpassword"
        />
        <template slot="footer">
          <a-button
            @click="
              shouChangepw = false;
              passwordEdit.oldpassword = '';
              passwordEdit.password = '';
              passwordEdit.confirmpassword = '';
            "
            >取消</a-button
          >
          <a-button
            style="background: #870000; color: #fff"
            @click="handleOkChangepw"
            >确认</a-button
          >
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import { goLogin,LogOut,updatePassword} from "../../api";
import login from "../../components/login";
export default {
  components: {
    login,
  },
  data() {
    return {
      showLoginPop: false,
      urllist: [
        { name: "首页", path: "/home/index1" },
        { name: "通知公告", path: "/notice/list" },
        { name: "作品展示", path: "/workshow" }
      ],
      shouUserMore: false,
      shouChangepw: false,
      passwordEdit: {
        username: "",
        oldpassword: "",
        password: "",
        confirmpassword: "",
      },
    };
  },
  mounted() {},
  methods: {
    handleOkChangepw() {
      this.passwordEdit.username = this.$store.state.user.username;
      updatePassword(this.passwordEdit).then((res) => {
        if (res.code === 200) {
          this.shouChangepw = false;
          this.passwordEdit.oldpassword = "";
          this.passwordEdit.password = "";
          this.passwordEdit.confirmpassword = "";
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    goRegister(){
          this.$router.push({path:'/register'});
    },
    goLogins(){
        this.showLoginPop=true;
    },
    gohref(path){
        this.$router.push({path:path});
    },
    close() {
      this.showLoginPop = false;
    },
    gojump(){
        this.$router.push({ name:"alApply",});
    },
    gojumpS(){
        this.$router.push({ name:"lottery",});
    },
    logout() {
      LogOut().then((res) => {
        if (res.code === 200) {
          window.sessionStorage.clear();
          this.$store.state.token = null;
          this.$router.push("/home");
        }
      });
    },
  }
};
</script>
  <style lang="scss" scoped>
@import "@/assets/style/mixin.scss";
.wd12 {
  width: 1250px;
  height: auto;
  margin: 0px auto;
}
.flex {
  display: flex;
}
.space-ar {
  justify-content: space-between;
}
.loginPop {
  position: fixed;
  top:0px;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.52);
}
.user-more {
  position: absolute;
  width: 100%;
  min-width: 134px;
  top: 46px;
  padding: 0 10px;
  left: -27px;
  z-index: 99;
  background: #fff;
  border: 1px solid #ffffff;
  border-radius:5px;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.18);
}
.user-more-item:hover {
  color: #870000;
}
.user-box {
  position: relative;
  cursor: pointer;
}
.user-more-item {
  margin: 12px 0;
  text-align: center;
  color: #000;
}
.bhbox {
  background-color: #fff;
  min-height: 100vh;
  .bhbanner {
    width: 100%;
    height: 644px;
    //background: url("~@/assets/images/bh/banner.png") no-repeat;
    background: url("~@/assets/images/tjbh/banner.png") no-repeat;
    background-size: 100% 100%;
    // background-position: top;
    .topheader {
      width: 100%;
      height: 80px;
      // background: #68aee6;
      .topfix {
        height: 80px;
        align-items: center;
        .toplogo {
          width: 280px;
          height: auto;
        }
        .topmenu {
          width: 600px;
          height: 60px;
          justify-content: flex-start;
          .menuitem {
            height: 60px;
            line-height: 60px;
            display: inline-block;
            margin: 0px 30px;
            color: #24272C;
            font-size: 20px;
            position: relative;
            width: 90px;
            cursor: pointer;
            text-align: center;
            .menuline {
              width: 100%;
              height: 6px;
              position: absolute;
              left: 0px;
              bottom: 0px;
              background-color: #F58947;
              border-radius: 3px;
              // background: url("~@/assets/images/bh/activeline.png") no-repeat;
              // background-size: 100% 100%;
            }
          }
          .menuactive {
            font-weight: bold;
          }
        }
        .toplogin {
          width: 85px;
          height: 31px;
          text-align: center;
          line-height: 31px;
          color: #fff;
          font-size: 16px;
          background-color: #870000;
          border-radius: 15px;
          cursor: pointer;
        }
         .toplogins {
          width: 85px;
          height: 31px;
          text-align: center;
          line-height: 31px;
          color: #333;
          font-size: 16px;
          background-color: #e5e5e5;
          border-radius: 15px;
          cursor: pointer;
        }
      }
    }
  }
  .footer {
    height: 142px;
    background-color: #5D1000;
    padding: 20px 0px;
    box-sizing: border-box;
    .footerw {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 102px;
    }
    .bottomlogo {
      width: 300px;
      height: auto;
      padding-left: 30px;
    }
    .bottomline {
      width: 1px;
      height: 110px;
      margin: 0px 100px;
    }
    .bottomheight {
      padding: 24px 0px 0px;
      color: #fff;
      font-size: 16px;
    }
  }
}
@media (min-width: 1024px) and (max-width: 1440px) {
  .bhbox {
    .bhbanner {
      height:450px;
    }
  }
}
.img-small {
  width: 10px;
  height: 10px;
  margin-left: 8px;
  margin-right: 12px;
}
</style>